<div class="custom-tooltip">
  <div class="tooltip-item">
    <img src="/assets/icons/{{ passCond1 ? 'tick.svg' : 'cross.svg' }}" />
    <p class="tooltip-text {{ passCond1 ? 'text-green' : 'text-red' }}">
      8 characters minimum
    </p>
  </div>
  <div class="tooltip-item">
    <img src="/assets/icons/{{ passCond2 ? 'tick.svg' : 'cross.svg' }}" />
    <p class="tooltip-text {{ passCond2 ? 'text-green' : 'text-red' }}">
      One number
    </p>
  </div>
  <div class="tooltip-item">
    <img src="/assets/icons/{{ passCond3 ? 'tick.svg' : 'cross.svg' }}" />
    <p class="tooltip-text {{ passCond3 ? 'text-green' : 'text-red' }}">
      One special character
    </p>
  </div>
  <div class="tooltip-item">
    <img src="/assets/icons/{{ passCond4 ? 'tick.svg' : 'cross.svg' }}" />
    <p class="tooltip-text {{ passCond4 ? 'text-green' : 'text-red' }}">
      One upper case letter
    </p>
  </div>
  <div class="tooltip-item">
    <img src="/assets/icons/{{ passCond5 ? 'tick.svg' : 'cross.svg' }}" />
    <p class="tooltip-text {{ passCond5 ? 'text-green' : 'text-red' }}">
      One lower case letter
    </p>
  </div>
</div>